import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  issueId: string;
};

export const adminGetIssuePossibleDuplicates = createQueryFn(
  QueryNameSpace.adminGetIssuePossibleDuplicates,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, { issueId }] = queryKey;

    return (await DigiobcanApi.adminGetIssuePossibleDuplicates(issueId))
      .possible_duplicates;
  },
);
